import { createElement } from "react"
import { AppRouteConfig } from "@/types/navigation"
import { ROUTES } from "./path"
import ListResources from "@/pages/dashboard/resource/list"
import CreateResource from "@/pages/dashboard/resource/create"
import ConfigureResource from "@/pages/dashboard/resource/configure"
import ManageResource from "@/pages/dashboard/resource/manage"
import ResourceSettings from "@/pages/dashboard/resource/settings"

export const resourceRoutes: AppRouteConfig[] = [
  {
    path: ROUTES.DASHBOARD.RESOURCES.INDEX,
    element: createElement(ListResources),
    restricted: true,
    showNav: true,
    showSideBar: true,
  },
  {
    path: ROUTES.DASHBOARD.RESOURCES.CREATE,
    element: createElement(CreateResource),
    restricted: true,
    showNav: false,
    showSideBar: false,
  },
  {
    path: ROUTES.DASHBOARD.RESOURCES.CONFIGURE(":id"),
    element: createElement(ConfigureResource),
    restricted: true,
    showNav: false,
    showSideBar: false,
  },
  {
    path: ROUTES.DASHBOARD.RESOURCES.MANAGE(":id"),
    element: createElement(ManageResource),
    restricted: true,
    showNav: false,
    showSideBar: false,
  },
  {
    path: ROUTES.DASHBOARD.RESOURCES.MANAGE_CONTAINER(":id", ":containerId"),
    element: createElement(ManageResource),
    restricted: true,
    showNav: false,
    showSideBar: false,
  },
  {
    path: ROUTES.DASHBOARD.RESOURCES.SETTINGS(":id"),
    element: createElement(ResourceSettings),
    restricted: true,
    showNav: false,
    showSideBar: false,
  },
]
